import { useEffect, useState } from "react";
import { fetchPopularBlogPosts } from "../../api/GlobalApi";
import { Link } from "react-router-dom";

function HomePopularPosts () {

    const [blogPosts, setBlogPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchPopularBlogPosts()
        .then((data) => {
            setBlogPosts(Array.isArray(data) ? data : []);
            setLoading(false);
        })
        .catch(() => setLoading(false));
    }, []);

    function formatDate(dateString) {
        if (!dateString) return "N/A";
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric"
        });
    }

    if (loading) return <p>Loading Latest Posts...</p>;

    return (
        <section class="section">
            <div class="section-header">
                <h2 class="section-title">Popular this month</h2>
                <Link to={'/blogs/popular'} class="see-more">See all</Link>
            </div>
            <div class="games-grid">
                {blogPosts.slice(0, 8).map((post) => (
                    <Link to={`/blog/${post.slug}`} class="game-card" style={{textDecoration: "none"}}>
                        <div class="game-image" style={{
                            background: "linear-gradient(45deg, #ff9a9e, #fad0c4)",
                            backgroundImage: `url(${post.featured_image_url})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",}}>
                            <div class="game-icon" style={{
                                backgroundImage: `url(${post.avatar_url})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",}}>
                            </div>
                        </div>
                        <div class="game-info">
                            <div class="game-title">{post.title}</div>
                            <div class="game-developer">{post.category} • {post.views_count} Views</div>
                            <div class="game-rating">
                                <span class="rating-text">{formatDate(post.updated_at)}</span>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </section>
    );
}

export default HomePopularPosts;